import { Location } from 'history';
import { CALL_HISTORY_METHOD, LOCATION_CHANGE } from './constants';

// Re-export constants for convenience
export { LOCATION_CHANGE, CALL_HISTORY_METHOD };

export interface RouterAction {
  type: typeof CALL_HISTORY_METHOD;
  payload: {
    method: string;
    args: any[];
  };
}

export interface LocationAction {
  type: typeof LOCATION_CHANGE;
  payload: Location;
}

// Helper to create the navigation actions
function updateLocation(method: string) {
  return (...args: any[]): RouterAction => ({
    type: CALL_HISTORY_METHOD,
    payload: { method, args },
  });
}

// Export the navigation methods used by Sagas
export const push = updateLocation('push');
export const replace = updateLocation('replace');
export const go = updateLocation('go');
export const goBack = updateLocation('goBack');
export const goForward = updateLocation('goForward');

// Keep this for reducer compatibility if needed
export const routeActions = {
  push,
  replace,
  go,
  goBack,
  goForward,
};